import {
  CardActionArea,
  CardMedia,
  CardContent,
  Typography,
  CardActions,
  Button,
  Card,
  IconButton,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import { useAuth } from "../../context/GlobalState";

export default function Product({ id, title, price, img, rate }) {
  const { dispatch } = useAuth();

  const addToBasket = () => {
    dispatch({
      type: "ADD_TO_BASKET",
      item: {
        title,
        id,
        price,
        img,
        rate,
      },
    });
  };
  return (
    <Card sx={{ minWidth: "25%"}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="400px"
          sx={{ objectFit: "contain" }}
          image={img}
          alt="green iguana"
        />
        <CardContent>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {title}
          </Typography>
          <Typography
            gutterBottom
            variant="h6"
            component="div"
            sx={{ textAlign: { xs: "center", sm: "left" }, display: "block" }}
          >
            {price}$
          </Typography>
          <Typography
            gutterBottom
            variant="h6"
            component="div"
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: { xs: "center", sm: "left" },
            }}
          >
            {Array(rate)
              .fill()
              .map((_, i) => (
                <p key={i}>
                  <StarIcon color="warning" />
                </p>
              ))}
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions sx={{ textAlign: "center", display: "block" }}>
        <Button
          onClick={addToBasket}
          size="medium"
          sx={{
            bgcolor: "#fcd115",
            color: "#111",
            width: "60%",
            mb: 1,
          }}
        >
          BUY NOW
        </Button>
      </CardActions>
    </Card>
  );
}
